import router from './router'

// تابع گرفتن متای ترکیب‌شده از matched routes
export function getMergedMeta (route) {
  return route.matched.reduce((acc, record) => {
    return { ...acc, ...record.meta }
  }, {})
}

// add method and property to router
router.getMergedMeta = (route = router.currentRoute) => getMergedMeta(route)

Object.defineProperty(router, 'meta', {
  get () {
    return getMergedMeta(this.currentRoute)
  }
})

export default router
